// Do not add new keys here - Add new dialogs in DIALOG_KEYS
export const LEGACY_DIALOG_KEYS = {
  AddListingToTourModal: 'AddListingToTourModal',
  OnboardingWelcomeModal: 'OnboardingWelcomeModal',
  SetupBrokerageWizardModal: 'SetupBrokerageWizardModal',
  OnboardingPreLaunchModal: 'OnboardingPreLaunchModal',
  UserSuggestedUpdateModal: 'UserSuggestedUpdateModal',
  FeedbackModal: 'FeedbackModal',
  AppointmentActionModal: 'AppointmentActionModal',
  ContextualChatModal: 'ContextualChatModal',
} as const;

// NEW keys add here
export const DIALOG_KEYS = {
  ...LEGACY_DIALOG_KEYS,
  LinkAccountModal: 'LinkAccountModal',
  BulkSubscriptionManagerModal: 'BulkSubscriptionManagerModal',
  BulkSubscriptionCsvDownloadModal: 'BulkSubscriptionCsvDownloadModal',
} as const;
